import React, { useState } from "react";

const getXMonths = (numOfMonths: number): { id: string; value: number; name: string }[] => {
	const result: { id: string; value: number; name: string }[] = [];

	const dateNow = new Date();
	let currentMonth = dateNow.getMonth(); // 0 = January, 11 = December

	for (let i = 0; i <= numOfMonths; i++) {
		const year = dateNow.getFullYear();

		// Format the quarter and year as "{year}-Q{x}"
		const formatted = `${year}-${(currentMonth + 1).toString().padStart(2, "0")}`;

		result.push({
			id: `previous_${i}-${i}_months`,
			value: currentMonth,
			name: formatted,
		});

		// Move to the previous quarter
		currentMonth--;
		if (currentMonth <= 0) {
			currentMonth = 12;
			dateNow.setFullYear(dateNow.getFullYear() - 1);
		}
	}

	return result;
};

interface Props {
	name: string;
	filter?: Record<string, string>;
	onChange: (value: Record<string, string>) => void;
}

export const MonthReportCombo = (props: Props) => {
	const [value, setValue] = useState<string | undefined>(props.filter ? props.filter[props.name] : undefined);
	const months = getXMonths(12);

	const onChange = (newValue: string) => {
		const filter = months.filter((x) => x.id === newValue)[0];
		setValue(filter.id);
		const parserFilters: Record<string, any> = {
			[props.name]: `${filter.id}`,
		};

		props.onChange(parserFilters);
	};
	return (
		<div className="content-navigation">
			<div role="group" className="me-2 text-nowrap flex-wrap dashboard-filters-buttons btn-group">
				{months.map((month) => {
					return (
						<button
							type="button"
							onClick={() => onChange(month.id)}
							className={`btn${value && month.id === value ? " btn-primary" : " btn-default"}`}
							key={month.id}
						>
							{month.name}
						</button>
					);
				})}
			</div>
		</div>
	);
};
